import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../routes/constants';
import { UnlockIcon } from '../../../svg';
import { Button } from '../Button';
import { t } from 'i18next';

export interface UpgradeBannerProps {
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  headingProps?: React.HTMLAttributes<HTMLHeadingElement>;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  linkTo?: string;
  headingText?: string;
  buttonText?: string;
  showIcon?: boolean;
  icon?: React.ReactNode;
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({
  containerProps,
  headingProps,
  buttonProps,
  linkTo = ROUTES.PLANS,
  headingText = t('upgrade.title'),
  buttonText = t('common.upgradeNow'),
  showIcon = true,
  icon = (
    <UnlockIcon
      className="size-4 cursor-pointer select-none"
      stroke="#ffffff"
    />
  ),
}) => {
  return (
    <div
      {...containerProps}
      className={`absolute top-[58px] right-0 bottom-0 left-0 backdrop-blur-md flex flex-col items-center justify-center z-10 ${
        containerProps?.className || ''
      }`}
    >
      <h2
        {...headingProps}
        className={`text-lg font-medium mb-6 text-center ${
          headingProps?.className || ''
        }`}
      >
        {headingText}
      </h2>
      <Link to={linkTo}>
        <Button
          {...buttonProps}
          className={`flex gap-2 items-center ${buttonProps?.className || ''}`}
        >
          {showIcon && icon}
          {buttonText}
        </Button>
      </Link>
    </div>
  );
};

export default UpgradeBanner;
